import { useRef, useState } from "react";
import { useTextareaAutosize } from "./useTextareaAutosize";

export function AutosizeDemo({ minRows = 1, maxRows = 6, placeholder = "Type here…" }) {
  const ref = useRef(null);
  const [text, setText] = useState("");
  const height = useTextareaAutosize(ref, text, { minRows, maxRows });
  return (
    <textarea
      ref={ref}
      value={text}
      onChange={(e) => setText(e.target.value)}
      placeholder={placeholder}
      style={{
        width: "100%",
        maxWidth: "32rem",
        padding: "0.5rem",
        fontSize: "0.875rem",
        lineHeight: "1.25rem",
        border: "1px solid #d6d6d6",
        borderRadius: "0.375rem",
        resize: "none",
        overflowY: "auto",
        boxSizing: "border-box",
        height,
      }}
    />
  );
}

## Basic Usage

<AutosizeDemo />

Type multiple lines — the textarea grows up to 6 rows, then scrolls. Pass a ref, the current
value, and optional `minRows` / `maxRows`. The hook returns a CSS height string the consumer
applies via `style={{ height }}`.

---

## Tight clamp (1–3 rows)

<AutosizeDemo minRows={1} maxRows={3} placeholder="Caps at 3 rows" />

---

## Multi-row minimum (3 rows always visible)

<AutosizeDemo minRows={3} maxRows={8} placeholder="Always shows at least 3 rows" />
